import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import _ from "lodash";
import moment from "moment-timezone";
import styled from "styled-components";

import StatusLabel, { BookingStatuses } from "components/ui-kit/status-label";
import { Button, Container, Frame, Row, RowWrapper } from "components/ui-kit/styled-templates";

import EventsApi from "api/events-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";

const EventPreviewBookingPage = () => {
    const { t } = useTranslation();

    useBodyBackground(`white`);

    const navigate = useNavigate();
    const { requestId, bookingId } = useParams();
    const booking = useStorageListener(`bookings.${bookingId}`, {});
    const { dormitoryId } = booking;

    const request = useStorageListener(`events-requests.${requestId}`, []);
    const event = useStorageListener(`events.${request.eventId}`, {});

    const handlers = {
        openDeleteBookinModality: () =>
            ModalsService.showModality({
                title: `Отмена бронирования`,
                description: `Вы уверены, что хотите отменить это бронирование?`,
                cancelButton: {
                    children: `Нет, не отменять`,
                    background: `gray`,
                },
                confirmButton: {
                    children: `Да, отменить бронирование`,
                    background: `red`,
                    onClick: async () => {
                        await EventsApi.deleteBooking(requestId);
                        navigate(`/event-requests`);
                    },
                },
            }),
    };

    // @ts-ignore
    useEffect(EventsApi.getAllBookings, []);

    // // @ts-ignore
    // useEffect(async () => {
    //     if (!dormitory) {
    //         try {
    //             await DormitoriesApi.getDormitoryInfo(dormitoryId);
    //         } catch (error) {
    //             navigate(`/requests`);
    //         }
    //     }
    // }, [dormitoryId, dormitory]);
    // // @ts-ignore
    // useEffect(() => {
    //     if (!dormitory && !dormitoryId) {
    //         RoomsApi.getDormitoryRooms(dormitoryId);
    //     }
    // }, [dormitoryId, dormitory]);
    // // @ts-ignore
    // useEffect(UniversityApi.getAllUniversitiesData, []);
    // // @ts-ignore
    // useEffect(() => {
    //     if (!booking.dormitoryId) {
    //         BookingsApi.getMyBookings();
    //     }
    // }, [bookingId]);

    return (
        <>
            <HeaderWrapper>
                <Container>
                    <RowWrapper extra="@media (max-width: 991px) { flex-direction: column; };">
                        <h1>{moment(booking?.timestamp).format('DD.MM.YYYY HH:mm')}</h1>
                        <Row extra="gap: 24px; @media (max-width: 991px) { flex-direction: column; };">
                            <Button variant="outlined" background="red" onClick={handlers.openDeleteBookinModality}>
                                {t("vu9dio2uvt9")}
                            </Button>
                            <Link to={`/edit-event-booking/${requestId}`}>
                                <Button variant="outlined" background="blue">
                                    {t("6b2s7oezigi")}
                                </Button>
                            </Link>
                        </Row>
                    </RowWrapper>
                </Container>
            </HeaderWrapper>
            <Container extra={`align-items: flex-start; margin-top: 15px;`}>
                <StatusLabel status={request.status}>{BookingStatuses[request.status]}</StatusLabel>
                <h3 className={'mt-6'} >{_.get(event, `details.name`)}</h3>

                {request?.details?.fullName && (
                    <div className={'my-2'} >
                        <strong>ФИО</strong>: {_.get(request, "details.fullName", "-")}
                    </div>
                )}

                {request?.details?.phone && (
                    <div className={'my-2'} >
                        <strong>Телефон</strong>: {_.get(request, "details.phone", "-")}
                    </div>
                )}

                {request?.details?.email && (
                    <div className={'my-2'} >
                        <strong>Email</strong>: {_.get(request, "details.email", "-")}
                    </div>
                )}

                <AccommodationBlock>
                    <div className={'my-2'} >
                        <strong>Требуется размещение на базе ООВО</strong>:{' '}
                        <span style={{ color: request?.details?.needsAccommodation ? '#02bf89' : '#666' }}>
                            {request?.details?.needsAccommodation ? 'Да' : 'Нет'}
                        </span>
                    </div>
                    {request?.details?.needsAccommodation && request?.details?.accommodationInfo && (
                        <div className={'my-2'} style={{ marginLeft: '10px', padding: '10px', background: '#f5f7fa', borderRadius: '8px' }}>
                            <strong>Информация о размещении</strong>:
                            <div style={{ marginTop: '5px', whiteSpace: 'pre-wrap' }}>
                                {request?.details?.accommodationInfo}
                            </div>
                        </div>
                    )}
                </AccommodationBlock>

                <Frame extra="flex-direction: row; flex-wrap: wrap; gap: 50px; margin: 30px 0; max-width: 450px; justify-content: space-between; @media (max-width: 991px) { flex-direction: column; };">
                    {[
                        { title: `Дата подачи`, text: moment(_.get(request, "timestamp")).format(`DD.MM.YYYY`) },
                        { title: `Кол-во мест:`, text: _.get(request, "details.quantity") },
                    ].map(({ title, text }, index) => (
                        <Frame key={index} extra="gap: 8px; align-items: flex-start; width: 200px;">
                            <div>{title}</div>
                            <strong>{text}</strong>
                        </Frame>
                    ))}
                </Frame>




                {/*<h3>{t("ffnucs6egrc")}</h3>*/}
                <div>
                    {_.get(request, `details.participants`, [])?.map?.((participant, index) => {
                        return (
                            <Fragment key={index}>
                                <h4>
                                    {t("v5nsop4qgh")}
                                    {index + 1}
                                </h4>
                                <div>
                                    <strong>{t("jozl71vw3pg")}</strong>: {_.get(participant, "fullName", "-")}
                                </div>
                                <div>
                                    <span>{t("4bpvoi839fl")}</span>: {_.get(participant, "phone", "-")}
                                </div>
                                <div>
                                    <span>Email</span>: {_.get(participant, "email", "-")}
                                </div>
                            </Fragment>
                        );
                    })}
                </div>



                {/*{JSON.stringify(request)}*/}

            </Container>
        </>
    );
};

const HeaderWrapper = styled(Frame)`
    width: 100vw;
    background: ${({ theme }) => theme.background.support};

    h1 {
        margin: 24px;
    }
`;

const AccommodationBlock = styled.div`
    margin: 15px 0;
    padding: 15px;
    border: 1px solid #e3ecf4;
    border-radius: 8px;
    background: #fafbfc;
`;

export default EventPreviewBookingPage;
